<template>
    <b-sidebar
      id="add-new-user-sidebar"
      :visible="isAddNewMemberSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="$emit('clicked',false);$refs.simpleRules.reset();userData=blankUserData"
      @change="(val) => $emit('one')"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            課程 {{ action }}
          </h5>
         
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
  
        </div>
        <!-- BODY -->
        <validation-observer
          ref="simpleRules"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
  
            <!-- Username -->
            <validation-provider
              #default="validationContext"
              name="Name"
              rules="required"
            >
              <b-form-group
                label="名稱 *"
                label-for="zh_name"
              >
                <b-form-input
                  id="zh_name"
                  v-model="userData.name"
                  :state="getValidationState(validationContext)"
                  trim
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
  
            <!-- Email -->
            <validation-provider
              #default="validationContext"
              name="Lesson Duration"
              rules="required"
            >
              <b-form-group
                label="課程總月份 *"
                label-for="lesson_duration"
              >
                <b-form-input
                  id="en_name"
                  v-model="userData.lesson_duration"
                  class="text-uppercase"
                  :state="getValidationState(validationContext)"
                  trim
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
  
  
              <validation-provider
              #default="validationContext"
              name="lesson paid"
               rules="required"
            >
              <b-form-group
                label="課程付費月份 *"
                label-for="lesson_paid"
              >
                <b-form-input
                  id="lesson_paid"
                  v-model="userData.lesson_paid"
                  :state="getValidationState(validationContext)"
                  trim
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
  
  
  
              <validation-provider
                #default="validationContext"
                name="Start"
  
              >
  
                <b-form-group
                  label="生效 *"
                  label-for="start_at"
                  :state="getValidationState(validationContext)"
                >
                  <flat-pickr
                    v-model="userData.start_at"
                    class="form-control"
                    :config="{ dateFormat: 'Y-m-d'}"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
  
              <validation-provider
                #default="validationContext"
                name="Start"
              >
  
                <b-form-group
                  label="到期 *"
                  label-for="expire_at"
                  :state="getValidationState(validationContext)"
                >
                  <flat-pickr
                    v-model="userData.expire_at"
                    class="form-control"
                    :config="{ dateFormat: 'Y-m-d'}"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>


            <validation-provider
              #default="validationContext"
              name="is_newjoiner"
              rules="required"
            >
              <b-form-group
                label="新生 *"
                label-for="is_newjoiner"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="userData.is_newjoiner"
                  :options="YNOptions"
                  :clearable="false"
                  :reduce="val => val.value"
                  input-id="is_newjoiner"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              name="組合"
            >
              <b-form-group
                label="組合 *"
                label-for="組合"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="userData.product_set_id"
                  :options="product_set_option"
                  :clearable="false"
                  label="name"
                  :reduce="val => val.id"
                  input-id="組合"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              name="status"
              rules="required"
            >
              <b-form-group
                label="狀態 *"
                label-for="status"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="userData.status"
                  :options="statusOption"
                  :clearable="false"
                  input-id="status"
                  :reduce="val => val.value"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
  
            <!-- Form Actions -->
            <div class="d-flex mt-2 mb-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="button"
                :disabled="processing"
                @click="submit_now()"
              >
                確定
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                取消
              </b-button>
            </div>
              <br><br><br><br><br><br><br>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </template>
  
  <script>
  import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import flatPickr from 'vue-flatpickr-component'
  import { ref } from '@vue/composition-api'
  import { required, alphaNum, email } from '@validations'
  import formValidation from '@core/comp-functions/forms/form-validation'
  import Ripple from 'vue-ripple-directive'
  import vSelect from 'vue-select'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import countries from '@/@fake-db/data/other/countries'
  
  export default {
    components: {
      ToastificationContent,
      flatPickr,
      BSidebar,
      BForm,
      BFormGroup,
      BFormInput,
      BFormInvalidFeedback,
      BButton,
      vSelect,
  
      // Form Validation
      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      Ripple,
    },
    model: {
      prop: 'isAddNewMemberSidebarActive',
      event: 'update:is-add-new-Member-sidebar-active',
    },
    props: {
      userData: {
        type:Object
      },
      action: {
        required: true,
      },
      isAddNewMemberSidebarActive: {
        type: Boolean,
        required: true,
      },
      genderOptions: {
        type: Array,
        required: true,
      },
      planOptions: {
        type: Array,
        required: true,
      },
  
      statusOptions: {
        type: Array,
        required: true,
      },
      centerOptions: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        required,
        processing: false,
        alphaNum,
       
        email,
        countries,
        blankUserData: {
          display_name: '',
          status: '',
        },
        schoolGradeOptions: [
          { label: 'N', value: 'N' },
          { label: 'K1', value: 'K1' },
          { label: 'K2', value: 'K2' },
          { label: 'K3', value: 'K3' },
          { label: 'P1', value: 'P1' },
          { label: 'P2', value: 'P2' },
          { label: 'P3', value: 'P3' },
          { label: 'P4', value: 'P4' },
          { label: 'P5', value: 'P5' },
          { label: 'P6', value: 'P6' },
        ],
        YNOptions: [
        { label: 'Y', value: 'Y' },
        { label: 'N', value: 'N' },
        ],
        product_set_option: [],
        statusOption: [
        { label: 'ACTIVE', value: 'ACTIVE' },
        { label: 'DISABLED', value: 'DISABLED' },
        { label: 'DELETED', value: 'DELETED' },
        ]
      }
    },
    created() {
      this.get_product_set()
    },
    methods: {
      get_product_set() {
        this.$http.get(process.env.VUE_APP_API_BASE + '/product_set/')
          .then(res => {
            this.product_set_option = res.data.product_set
          })
      },
      resetForm() {
  
      },
      submit_now() {
        var api = null
        if (this.action == 'add') {
          api = '/packages/'
        } else {
          api = '/package/' + this.userData.id + '/edit/'
        }
        this.processing = true
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
           
            this.$http.post(process.env.VUE_APP_API_BASE+ api, this.userData)
              .then(res => {
                if (res.data.result === true) {
                  this.$emit('clicked', false)
                 
                  this.$refs.simpleRules.reset()
                  this.processing = false
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  })
                  this.processing = false
                }
              })
          }
        })
      },
    },
    setup(props, { emit }) {
      const blankUserData = {
        status: 'ACTIVE',
      }
  
      const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
      const resetuserData = () => {
        userData.value = JSON.parse(JSON.stringify(blankUserData))
      }
  
      const onSubmit = () => {
  
      }
  
      const {
        refFormObserver,
        getValidationState,
      } = formValidation(resetuserData)
  
      return {
        userData,
        onSubmit,
  
        refFormObserver,
        getValidationState,
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  #add-new-user-sidebar {
    .vs__dropdown-menu {
      max-height: 200px !important;
    }
  }
  </style>
  